import { useCallback, useState } from 'react'

import { AskAiChatSidePanel } from './AskAiChatSidePanel'
import * as S from './AskRemyLauncher.styles'
import { useDraggableLauncher } from './useDraggableLauncher'

// Global entry point to Remy: a floating action button that starts in the
// bottom-right of every screen and can be dragged anywhere in the viewport so
// it never has to cover page controls. Hover/focus expands it into a pill
// with the "Ask Remy" label; clicking opens the chat side panel. The button
// hides while the panel is open so it never overlaps the chat.
export const AskRemyLauncher = () => {
  const [open, setOpen] = useState(false)
  const [everOpened, setEverOpened] = useState(false)

  const openPanel = useCallback(() => {
    setEverOpened(true)
    setOpen(true)
  }, [])

  const { style, isDragging, dragHandlers } = useDraggableLauncher(openPanel)

  return (
    <>
      {/* Once opened, the panel stays mounted for the rest of the tab session so
          the conversation survives close/reopen; `open` only shows/hides it. */}
      {everOpened && <AskAiChatSidePanel open={open} onClose={() => setOpen(false)} />}

      {!open && (
        <S.LauncherButton
          type="button"
          aria-label="Ask Remy"
          style={style}
          $dragging={isDragging}
          {...dragHandlers}
        >
          {/* Paint source for the icon's animated sheen fill. */}
          <S.SheenDefs aria-hidden focusable="false">
            <defs>
              <linearGradient id="ask-remy-icon-sheen" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0" stopColor="#fff" />
                <stop offset="0.5" stopColor="#fff" />
                <stop offset="1" stopColor="#fff" />
              </linearGradient>
            </defs>
          </S.SheenDefs>
          <S.Icon width={20} height={20} />
          <S.Label>Ask Remy</S.Label>
        </S.LauncherButton>
      )}
    </>
  )
}
